<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <div style="padding: 24px 0;">
        <Row>
          <Col span="2"><div style="text-align: right; line-height: 26px;">标题：</div></Col>
          <Col span="22"><div style="line-height: 26px;">{{ complaint.title }}</div></Col>
        </Row>

        <Row>
          <Col span="2"><div style="text-align: right; line-height: 26px;">内容：</div></Col>
          <Col span="22"><div style="line-height: 26px;">{{ complaint.content }}</div></Col>
        </Row>

        <Row>
          <Col span="2"><div style="text-align: right; line-height: 26px;">真实姓名：</div></Col>
          <Col span="22"><div style="line-height: 26px;">{{ complaint.realName }}</div></Col>
        </Row>
        
        <Row>
          <Col span="2"><div style="text-align: right; line-height: 26px;">手机：</div></Col>
          <Col span="22"><div style="line-height: 26px;">{{ complaint.mobile }}</div></Col>
        </Row>

        <Row>
          <Col span="2"><div style="text-align: right; line-height: 26px;">状态：</div></Col>
          <Col span="22"><div style="line-height: 26px;">{{ complaint.statusTxt }}</div></Col>
        </Row>
        </div>
        <Row>
          <Col span="2"><div style="text-align: right; line-height: 36px;">回复：</div></Col>
          <Col span="22">

            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="0">
              <FormItem label="" prop="status">
                <RadioGroup v-model="formValidate.status">
                  <Radio label="1">通过</Radio>
                  <Radio label="-1">驳回</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="" prop="remark">
                <Input v-model="formValidate.remark" type="textarea" :rows="5" placeholder="输入回复内容..."></Input>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">回复</Button>
              </FormItem>
            </Form>
          </Col>
        </Row>

      </Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '../../utils/global'
import axios from 'axios'

export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread,
},
  data () {
    return {
      user: null,
      
      complaint: {},
      formValidate: {
        applyId: this.$route.query.id,
        status: '',
        remark: ''
      },
      ruleValidate: {
        status: [
          { required: true, message: '请选择受理状态', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
          { type: 'string', min: 20, message: '备注内容至少20个字', trigger: 'blur' }
        ]
      }
    }
  },

  mounted() {
    this.initUser()
    this.initMine()
  },
  methods: {
    //初始化用户信息
    initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

    initMine () {
      let vm = this
      let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/complaint/v1.0/apply/detail',
        headers: {
          token: this.user.token
        },
        data: {
          id: id
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          vm.complaint = response.data.data
        }
      });
    },

    //回复
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
      if (valid) {
        console.log(this.formValidate)
        let vm = this
        axios({
          method: 'post',
          url: global.restUrl + '/api/web/complaint/v1.0/reply/save',
          data: vm.formValidate,
          headers: {
            token: vm.user.token
          }
        }).then(function (response) {
          let success = response.data.success
          if(success) {
            vm.initMine()
            vm.$Message.success(response.data.message)
          }
        });
      } else {
        this.$Message.error('请您完善表单信息');
      }
      })
    },
  }
}
</script>
